import { isProd, isDev } from "@/config/constants";

const ACCOUNT_BASE_URL = isProd
  ? "https://sepautomation-api.dev.maersk-digital.net/sepApi/"
  : isDev
  ? "https://sepautomation-api.dev.maersk-digital.net/sepApi/"
  : "http://localhost:8081/sepApi/";

//User Details
export const getDistinctDemandFlowArea = `${ACCOUNT_BASE_URL}getDistinctDemandFlowArea`;
export const getDistinctDemandPool = `${ACCOUNT_BASE_URL}getDistinctDemandPool`;
export const getExportPoolFlowAreaSuggestion = `${ACCOUNT_BASE_URL}getExportPoolFlowAreaSuggestion`;
export const getPoolDemandSuggestion = `${ACCOUNT_BASE_URL}getPoolDemandSuggestion`;
export const getFlowAreaDemandSuggestion = `${ACCOUNT_BASE_URL}getFlowAreaDemandSuggestion`;
export const getMonthlyDistribution = `${ACCOUNT_BASE_URL}getMonthlyDistribution`;
export const getDistinctMonths = `${ACCOUNT_BASE_URL}getDistinctMonths`;
export const getDistinctService = `${ACCOUNT_BASE_URL}getDistinctService`;
export const getReasonResults = `${ACCOUNT_BASE_URL}getReasonResults`;
export const getUtilizationPerc = `${ACCOUNT_BASE_URL}getUtilizationPerc`;
export const getLostDemandInfo = `${ACCOUNT_BASE_URL}getLostDemandInfo`;
export const getFlowAreaLevelValues = `${ACCOUNT_BASE_URL}getFlowAreaLevelValues`;
export const getRouteDetail = `${ACCOUNT_BASE_URL}getRouteDetail`;
export const getDistinctweekPeriod = `${ACCOUNT_BASE_URL}getDistinctweekPeriod`;
export const getBottleneckLevelData = `${ACCOUNT_BASE_URL}getBottleneckLevelData`;
export const getMovesCountData = `${ACCOUNT_BASE_URL}getMovesCountData`;

